module.exports = __webpack_public_path__ + "media/Si247.fd05eb82.mp3";